



















































import { Component, Vue, Watch } from "vue-property-decorator";
import DataObject from "@/utility/DataObject";
import moment from "moment";

@Component
export default class Tanggal extends Vue {
  picker = false;
  now = null;
  type = "day";
  labelDay = "Hari ini";
  countDate = 0;
  btnPrev = false; // tdk disable = false
  btnNext = false;
  changeDay = "";

  // today = new Date().toISOString().substr(0, 10); // max date
  today = moment().format("YYYY-MM-DD");
  // start = new Date().toISOString().substr(0, 10); // form model input
  start = moment().format("YYYY-MM-DD"); // form model input
  myDate = new Date();
  dateRange = 7;
  minDate = new Date().toISOString().substr(0, 10); // min date

  get startDateFormattedMomentjs() {
    return this.start ? moment(this.start).format("DD MMMM YYYY") : "";
  }

  mounted() {
    DataObject.filterCari.count = 0;

    if (DataObject.filterCari.tanggal != "") {
      this.start = DataObject.filterCari.tanggal;
      this.countDate = DataObject.filterCari.count;
      this.myDate = new Date(this.start);
      this.pickDate();
    }

    const minn = new Date(
      new Date().setDate(new Date().getDate() - this.dateRange)
    );
    this.minDate = minn.toISOString().substring(0, 10);
    // console.log("start", this.start);
    // console.log("count", this.countDate);
    // console.log("mydate", this.myDate);

    // if (this.countDate == 0) {
    //   this.btnNext = true;
    // }
  }
  created() {
    DataObject.filterCari.count = 0;

    this.countDate = DataObject.filterCari.count;
    // console.log("countcreated", this.countDate);
    if (this.countDate == 0) {
      this.btnNext = true;
    } else if (this.countDate == this.dateRange) {
      this.btnPrev = true;
    }
  }
  @Watch("start")
  dateChanged(value: string, oldValue: string) {
    // this.lastName = value
    // console.log("Watch:", value, oldValue);

    this.$emit("changeDate", value);
    this.start = value;
  }

  pickDate() {
    const timeDiff = Math.abs(
      new Date(this.today).getTime() - new Date(this.start).getTime()
    );
    const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

    if (diffDays == this.dateRange) {
      this.btnPrev = true;
      this.btnNext = false;
      this.labelDay = diffDays + " hari yang lalu";
    } else if (diffDays > 0 && diffDays < this.dateRange) {
      this.btnPrev = false;
      this.btnNext = false;
      this.labelDay = diffDays + " hari yang lalu";
    } else {
      this.btnNext = true;
      this.btnPrev = false;
      this.labelDay = "Hari ini";
    }
  }

  prevDay() {
    if (this.countDate < this.dateRange) {
      this.myDate = new Date(this.myDate.setDate(this.myDate.getDate() - 1));
      this.start = moment(this.myDate).format("YYYY-MM-DD");
      this.btnNext = false;
      this.countDate++;
      // console.log("countdate", this.countDate);
      DataObject.filterCari.count = this.countDate;
      this.labelDay = this.countDate + " hari yang lalu";
      if (this.countDate == this.dateRange) {
        this.btnPrev = true;
      }
    } else {
      // this.myDate = new Date(this.myDate.setDate(this.myDate.getDate()));
      // this.start = moment(this.myDate).format('YYYY-MM-DD');
      this.btnPrev = true;
    }
  }

  nextDay() {
    // this.calendarInstance.next()
    // console.log("countdate", this.countDate);
    if (this.countDate >= 1) {
      this.myDate = new Date(this.myDate.setDate(this.myDate.getDate() + 1));
      this.start = moment(this.myDate).format("YYYY-MM-DD");
      // console.log("countdate", this.countDate);
      this.countDate--;
      this.labelDay = this.countDate + " hari yang lalu";
      DataObject.filterCari.count = this.countDate;
      // console.log("countdate", this.countDate);
      if (this.countDate == 0) {
        this.labelDay = "Hari ini";
        this.btnNext = true;
      }
      this.btnPrev = false;
      // this.calendarInstance.next()
    } else {
      this.myDate = new Date(this.myDate.setDate(this.myDate.getDate()));
      this.start = moment(this.myDate).format("YYYY-MM-DD");
      this.btnNext = true;
      this.labelDay = "Hari ini";
    }
  }
}
